import React from 'react'
import * as R from 'ramda'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { Reviews } from './common/Reviews/Reviews'
import { Edit3Icon } from 'components/shared/Icon/model'
import { ScoreChip } from 'components/shared/ScoreChip/ScoreChip'
import { Icon } from 'components/shared/Icon/Icon'
import {
  InterviewStateContext,
  InterviewHandlersContext,
} from 'components/modules/interview/context'
import { getFactorScoreTreshholds } from 'utils/score'
import { useContext } from 'hooks'

import styles from './Report.module.scss'

const mergeEvaluationCommentsIntoSkills = (skills, evaluation) => {
  const { evaluation_data = {}, email } = evaluation ?? {}
  if (!email || !skills) return skills ?? {}

  return R.mapObjIndexed((skill, sectionKey) => {
    const sectionData = evaluation_data[sectionKey]
    const comments = sectionData?.comments ?? {}
    if (R.isEmpty(comments)) return skill

    const reviews = skill?.reviews ?? {}
    const evaluatorReview = reviews[email] ?? {}
    return {
      ...skill,
      reviews: {
        ...reviews,
        [email]: {
          ...evaluatorReview,
          comments,
        },
      },
    }
  }, skills)
}

export const Report = () => {
  const state = useContext(InterviewStateContext)
  const { toggleEditMode } = useContext(InterviewHandlersContext)

  const {
    evaluation = {},
    evaluators,
    interviewAverageScore,
    candidate: { name },
    interviewSummary: { skills: rawSkills = {} } = {},
    sections = [],
  } = state

  const skills = mergeEvaluationCommentsIntoSkills(rawSkills, evaluation)

  return (
    <Box direction="column" className={styles.report}>
      <Box className={styles.header}>
        <Box>
          <h2 className={styles.titleSection}>
            <span className={styles.name}>{name}</span>
            <span className={styles.title}>{t`Interview report`}</span>
          </h2>
          <button className={styles.icon} onClick={() => toggleEditMode()}>
            <Icon icon={Edit3Icon} size={24} />
          </button>
        </Box>
        <Box className={styles.overallScore}>
          <span className={styles.scoreLabel}>{t`OVERALL SCORE`}</span>
          <ScoreChip
            score={interviewAverageScore}
            size="large"
            theme={getFactorScoreTreshholds(interviewAverageScore)}
          />
        </Box>
      </Box>
      <Reviews {...{ evaluators, sections, skills }} />
    </Box>
  )
}
